@if (hydrationFailed()) {

  <!-- role="alert" - the page is empty and the requester needs to know why
       without hunting for it. -->
  <div class="session-notice session-notice--error" role="alert" data-testid="hydration-failed-notice">
    <span class="session-notice__icon" aria-hidden="true">!</span>
    <p class="session-notice__text">
      Your saved work could not be loaded, so this page is showing nothing rather than
      what you had. Nothing has been lost — reload the page to try again.
    </p>
  </div>

} @else {

  @if (staleMessage(); as message) {
    <!-- role="status" - worth reading, but not urgent enough to interrupt. -->
    <div class="session-notice session-notice--stale" role="status" data-testid="stale-notice">
      <span class="session-notice__icon" aria-hidden="true">!</span>
      <p class="session-notice__text">{{ message }}</p>
    </div>
  }

}
